import posthog from 'posthog-js'

// Ad blockers ship path filters for PostHog's well-known asset names
// (e.g. EasyPrivacy has /posthog-recorder.js and /dead-clicks-autocapture.js).
// Serve those assets from renamed same-origin paths instead.
// Keep public/ph/pr.js and public/ph/dc.js in sync with the pinned posthog-js version.
const POSTHOG_ASSET_REWRITES: Record<string, string> = {
  '/static/posthog-recorder.js': '/ph/pr.js',
  '/static/dead-clicks-autocapture.js': '/ph/dc.js'
}

export default defineNuxtPlugin(() => {
  // Skip PostHog initialization during Cypress tests
  if (typeof window !== 'undefined' && window.Cypress) {
    return { provide: { posthog: null as any } }
  }

  const config = useRuntimeConfig()
  posthog.init(config.public.posthogToken, {
    api_host: 'https://ph.raftx24.dev',
    // api_host: 'https://eu.i.posthog.com',
    defaults: '2025-05-24',
    person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
    prepare_external_dependency_script: (script) => {
      const url = new URL(script.src)
      const rewrite = Object.entries(POSTHOG_ASSET_REWRITES).find(([from]) => url.pathname.includes(from))
      if (rewrite) {
        script.src = `${window.location.origin}${rewrite[1]}${url.search}`
      }
      return script
    }
  })

  return { provide: { posthog } }
})
